// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xaxg","content":"styles_content__2IakS","tableWrap":"styles_tableWrap__StIcp"};